var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05612 21.27186c.59402.69077 1.62226.80176 2.35001.25368l10.59383-7.9785 10.5938 7.97848c.72777.5481 1.75603.43711 2.35008-.25366.5467-.63572.47453-1.59426-.16119-2.14097a1.5181 1.5181 0 00-.07656-.06164L17.68443 10.7686c-.99738-.75114-2.37157-.75114-3.36894 0L3.2939 19.06926c-.66977.50442-.80381 1.4563-.2994 2.12606a1.51818 1.51818 0 00.06163.07654z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/nav-arrow.svg";
export { SvgNavArrow as ReactComponent };